import { AnchoringHeavingUpData } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const dataTag = 'AnchoringHeavingUpData';
export default class AnchoringHeavingUpParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.ANCHORING_HEAVING_UP, FIXED_PROTOCOL_CONTENT_TYPE_IDS.ANCHORING_HEAVING_UP, dataTag, app);
    }
    getPropsMapping() {
        return {
            anchor: 'anchor',
            freeText: 'freeText',
        };
    }
    createData(props, record) {
        const data = new AnchoringHeavingUpData(props.anchor, props.freeText);
        const linked = this.getLinked(record);
        if (linked) {
            const link = {
                protocol: linked,
                value: props.anchor,
            };
            data.anchor = link;
        }
        return data;
    }
}
//# sourceMappingURL=AnchoringHeavingUpParser.js.map